(function () {
  'use strict';

  // Skip the video upgrade entirely on slow / data-saver connections.
  function shouldSkipVideo() {
    var c = navigator.connection;
    if (!c) return false;
    if (c.saveData) return true;
    if (c.effectiveType === 'slow-2g' || c.effectiveType === '2g' || c.effectiveType === '3g') return true;
    return false;
  }

  function upgradeToVideo(container) {
    if (container.dataset.deferredVideoLoaded === '1') return;
    var src = container.getAttribute('data-video-src');
    var poster = container.getAttribute('data-video-poster');
    if (!src) return;
    container.dataset.deferredVideoLoaded = '1';

    var video = document.createElement('video');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.loop = true;
    video.autoplay = true;
    video.setAttribute('autoplay', '');
    video.preload = 'metadata';
    video.poster = poster || '';
    video.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';

    var source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);

    while (container.firstChild) container.removeChild(container.firstChild);
    container.appendChild(video);

    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () { /* autoplay blocked, leave poster visible */ });
    }
  }

  function init() {
    if (shouldSkipVideo()) return;
    var containers = document.querySelectorAll('.deferred-video[data-video-src]');
    if (!containers.length) return;
    containers.forEach(upgradeToVideo);
  }

  // Defer until the browser is idle so we never compete with LCP, even
  // on fast networks. requestIdleCallback gives the browser ~50ms of
  // breathing room after window.load before we touch the DOM.
  function schedule() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(init, { timeout: 2000 });
    } else {
      setTimeout(init, 200);
    }
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }
})();
